export default __webpack_public_path__ + "static/media/upload-folder.c01bbdbf.svg";